import { tss } from '@/shared/styles/tss'
import loadingBg from 'public/assets/temp/LoadingBg.webp?url'

export const useStyles = tss.withName('StartPage').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.colors.text.primary,
    width: '100vw',
    height: '100dvh',
    opacity: '0',
    transform: 'translateY(20px)',
    transition: 'opacity 0.5s, transform 0.5s',
    zIndex: '99999',

    backgroundImage: `url(${loadingBg})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',

    '&[data-visible="true"]': {
      opacity: '1',
      transform: 'translateY(0)',
    },
  },

  gamedContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  text: {
    fontSize: '16px',
    fontWeight: '450',
    color: 'rgba(255, 255, 255, 0.5)',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
    minHeight: '30px',
  },

  dizzaractContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    opacity: '0.5',
    color: 'rgba(250, 252, 255, 0.45)',
    position: 'fixed',
    bottom: '12px',
  }
}))
